__turbopack_context__.v({
  "quote_container": "styles-module-scss-module__rxNFCW__quote_container",
  "quote_left": "styles-module-scss-module__rxNFCW__quote_left",
  "quote_right": "styles-module-scss-module__rxNFCW__quote_right",
});
